import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { CustomModal, RenderTableHeaderValue, RenderTableCellValue } from '../../../resusableComponents/common/formElements';
import ReactDataTable from '../../../resusableComponents/common/ReactDataTable';

const PreviewTemplateModal = ({ show, templateId, previewData, onHide, onEdit, onExport, includeDominantTrait, onChangeDominantTrait, appendCustomFields, onChangeAppendCustomFields, isPreviewLoading }) => {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isPreviewLoading) {
      setLoading(true);
      return;
    }

    if (previewData && Array.isArray(previewData)) {
      setLoading(true);
      try {
        if (previewData.length > 0) {
          const headerRow = Object.keys(previewData[0]);

          const generatedColumns = headerRow.map((col, index) => ({
            name: <RenderTableHeaderValue value={col || `Column ${index + 1}`} />,
            selector: (row) => row[col] || "",
            cell: (row) => <RenderTableCellValue className="text-truncate" value={row[col] || ""} tooltip={true} />,
            sortable: false,
            minWidth: "150px"
          }));

          setColumns(generatedColumns);
          setData(previewData);
        } else {
          setColumns([]);
          setData([]);
        }
      } catch (e) {
        console.error("Error parsing preview data:", e);
      } finally {
        setLoading(false);
      }
    } else {
      setColumns([]);
      setData([]);
      setLoading(false);
    }
  }, [previewData, isPreviewLoading]);

  return (
    <CustomModal
      isOpen={show}
      size="xl"
      modalTitle={<FormattedMessage id="preview_template.modal.title" defaultMessage="Preview Template Data" />}
      onHide={onHide}
      onClose={onHide}
    >
      <div className="card">
        <div className="card-body">
          <div className="table-responsive custom-scroll">
            <ReactDataTable
              className="custom-scroll-460"
              columns={columns}
              data={data}
              progressPending={loading}
              pagination={false}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="d-flex flex-wrap gap-3">
              <div className="form-check form-check-inline heading-04 mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="includeDominantTraitCheckbox"
                  checked={includeDominantTrait || false}
                  onChange={(e) => onChangeDominantTrait && onChangeDominantTrait(e.target.checked)}
                />
                <label className="form-check-label fw-bold mb-0 cursor-pointer" htmlFor="includeDominantTraitCheckbox">
                  <FormattedMessage id="preview_template.checkbox.include_dominant_trait" defaultMessage="Include dominant trait" />
                </label>
              </div>
              <div className="form-check form-check-inline heading-04 mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="appendCustomFieldsCheckbox"
                  checked={appendCustomFields || false}
                  onChange={(e) => onChangeAppendCustomFields && onChangeAppendCustomFields(e.target.checked)}
                />
                <label className="form-check-label fw-bold mb-0 cursor-pointer" htmlFor="appendCustomFieldsCheckbox">
                  <FormattedMessage id="preview_template.checkbox.append_custom_fields" defaultMessage="Append Custom Fields" />
                </label>
              </div>
            </div>
            <div className="d-flex">
              <button className="btn btn-outline-secondary me-3 waves-effect" onClick={onHide} disabled={loading}>
                <FormattedMessage id="btn.cancel" defaultMessage="Cancel" />
              </button>
              <button className="btn btn-primary me-3 waves-effect" onClick={() => onEdit(templateId)} disabled={loading}>
                <FormattedMessage id="btn.edit" defaultMessage="Edit" />
              </button>
              <button className="btn btn-success waves-effect" onClick={() => onExport()} disabled={loading}>
                <FormattedMessage id="btn.export" defaultMessage="Export" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default PreviewTemplateModal;
